(function () {
  'use strict';
  angular.module('obex').
  factory('smsHistory', ['$rootScope', 'tripsDashBoard', 'currency',
    function ($rootScope, tripsDashBoard, currency) {
      $rootScope.smsHistory = {};
      return {
        addSmsMessage: function(number, sms) {
          var smsMessages = $rootScope.smsHistory[number];
          if (smsMessages === undefined) {
            $rootScope.smsHistory[number] = [];
          }

          $rootScope.smsHistory[number].push(sms);
        },

        retrieveSmsMessages: function(number) {
          return $rootScope.smsHistory[number];
        },

         
      };
    },
  ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/smsHistory.service.js